import AfiliadoConfig from "./AfiliadoConfig";

export default class AfiliadoService {
	static createAfiliado(value) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify(value);
				let endpoint = AfiliadoConfig.endpoint;
				let response = await AfiliadoConfig.APIConnector.post(endpoint, {
					body
				});
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static updateAfiliado(value) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify(value);
				let endpoint = AfiliadoConfig.endpoint;
				let response = await AfiliadoConfig.APIConnector.put(endpoint, {
					body
				});
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static getAfiliadoList(
		affiliateNumber,
		surname,
		name,
		documentNumber,
		cuil,
		status,
		page,
		size
	) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = AfiliadoConfig.endpoint + "?";
				if (affiliateNumber) endpoint += "&affiliateNumber=" + affiliateNumber;
				if (surname) endpoint += "&surname=" + surname;
				if (name) endpoint += "&name=" + name;
				if (status) endpoint += "&status=" + status;
				if (documentNumber) endpoint += "&documentNumber=" + documentNumber;
				if (cuil) endpoint += "&cuil=" + cuil;
				if (page !== null && size !== null)
					endpoint += "&page=" + page + "&size=" + size;
				let response = await AfiliadoConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static getContributions(idAffi) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = AfiliadoConfig.endpointGetContributions + "/" + idAffi;
				let response = await AfiliadoConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static processExcel(formData) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = AfiliadoConfig.endpointImportData;
				let response = await AfiliadoConfig.APIConnector.post(endpoint, {
					body: formData,
					multiPartFlag: true
				});
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static generateAffiliateCard(affiliate) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify(affiliate);
				let endpoint = AfiliadoConfig.endpointGenerateAffiliateCard;
				let response = await AfiliadoConfig.APIConnector.post(endpoint, {
					body
				});
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}
	static downloadFile(fileName) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = AfiliadoConfig.endpointReport;
				endpoint += `/${fileName}`;
				let response = await AfiliadoConfig.APIConnector.get(endpoint, {
					downloadFlag: true
				});
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}
	static validateCUIL(value) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = AfiliadoConfig.endpointValidateCUIL;
				let response = await AfiliadoConfig.APIConnector.get(
					endpoint + "/" + value
				);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/provider/Afiliado/AfiliadoService.js